import { BatchPrincipalsAndVicePrincipalsView } from "./BatchPrincipalsAndVicePrincipalsView";


export const BatchPrincipalsAndVicePrincipalsContainer = () => {
  return <BatchPrincipalsAndVicePrincipalsView />;
};
